const apply = {
	banner: [{
		tips: '申请EPD/CFP',
		title: '申请EPD/CFP',
		content: '',
		img: require('@/assets/img/index/EPD_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],
	label: {
		companyName: '企业名称',
		sampleName: '产品名称',
		address: '产品生产地址',
		productInfo: '产品描述',
		productCategory: '产品种类',
		type: '申请类别',
		licenseId: '工艺流程',
		ticketId: '产品图片',
		b_tips: '上传仅支持jpg和png格式，文件大小不超过100M',
		s_tips: '上传仅支持jpg和png格式，文件大小不超过100M',
		down: '下载开票信息模板',
		submit: '提交',
		reset: '重置',
		status: '认证状态',
		upload:'资料上传'
	},
	placeholder: {
		companyName: '请输入企业名称',
		sampleName: "请输入产品名称",
		address: '请输入产品生产地址',
		productInfo: '请描述产品的规格型号、产量、生产标准、质量标准等产品相关信息',
		productCategory: '请选择产品种类',
		type: '请选择申请类别',
		licenseId: '请上工艺流程图',
		ticketId: '请上传产品图片',
	},
	rules: {
		companyName: [{
			required: true,
			message: '请输入企业名称',
			trigger: 'blur'
		}, ],
		sampleName: [{
			required: true,
			message: '请输入产品名称',
			trigger: 'blur'
		}, ],
		address: [{
			required: true,
			message: '请输入产品生产地址',
			trigger: 'blur'
		}, ],
		productInfo: [{
			required: true,
			message: '请输入产品描述',
			trigger: 'blur'
		}, ],
		productCategory: [{
			required: true,
			message: '请选择产品种类',
			trigger: 'change'
		}, ],
		type: [{
			required: true,
			message: '请选择申请类别',
			trigger: 'change'
		}, ],
		licenseId: [{
			required: true,
			message: '请上工艺流程图',
			trigger: 'blur'
		}, ],
		ticketId: [{
			required: true,
			message: '请上传产品图片',
			trigger: 'blur'
		}, ],
	}
}

export default apply